import {SkipNavLink} from '@reach/skip-nav'
import '@reach/skip-nav/styles.css'
import './SkipNav.css'

function SkipNav() {
  return <SkipNavLink contentId="main-content-tag" />
}

export default SkipNav
